module.exports = __webpack_public_path__ + "media/images/icons/outlined/login-1c1738e5b7cbea6155c3c2f06d7d5343.svg";